export const bookingContainsSuspendedPassengers = ({ booking = {} }) =>
  [...(booking.outbound || []), ...(booking.inbound || [])]
    .filter(({ cancelled = false }) => !cancelled)
    .some(({ products = [] }) => products.filter(({ cancelled = false }) => !cancelled)?.some(({ isSuspended }) => isSuspended));
